/** Picks v2 or v1 of the Admin users list based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AdminsPage   from './AdminsPage';
import AdminsPageV2 from './v2/AdminsPageV2';

export default function AdminsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AdminsPageV2 : AdminsPage;
  return <Component {...props} />;
}
